import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { cleanEntity } from "../../Common/js/clean_entity"
import withHooks from "../../Common/jsx/WithHooks"
import { ENDPOINT_PLANTS, getPlant, getPlants, patchPlant, postPlant } from "../../api/api_plant"
import { getPeriods } from "../../api/api_period"
import { getObjectIdKey } from "../../Common/js/getObjectIdKey"
import { ENDPOINT_CHARACTERISTICS, getCharacteristics } from "../../api/api_characteristic"
import { ENDPOINT_FELLOWS } from "../../api/api_fellow"
import PlantsPeriodsGraph from "./PlantsPeriodsGraph"
import { getCharacTypes } from "../../api/api_charac_type"
import { ENDPOINT_FAMILIES, getFamilies } from "../../api/api_family"
import { ENDPOINT_MEDIAS } from "../../api/api_media"
import Select from "react-select"

class PlantForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      name: "",
      latin: "",
      vernacular: "",
      productivity: -1,
      growth: -1,
      foliage: -1,
      heightPlant: -1,
      sizeProduct: -1,
      needSun: -1,
      needWater: -1,
      seedingDepth: -1,
      distanceBetweenPlants: -1,
      distanceBetweenRows: -1,
      characteristics: [],
      fellows: [],
      media: [],
      methodSeeding: [],
      methodPlanting: [],
      methodGrowing: [],
      methodHarvesting: [],
      methodUtilization: [],
      methodConservation: [],
      periodSeedGlass: [],
      periodSeedSoil: [],
      periodPlanting: [],
      periodFlowering: [],
      periodHarvesting: [],
      importantNote: [],
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = false
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      periods: [],
      periodsAsObject: {},
      characTypes: [],
      characTypesAsObject: {},
      characteristics: [],
      characteristicsAsObject: {},
      sortedPlantCharacteristics: {},
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)
    this.sortCharacteristics = this.sortCharacteristics.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getPlant(this.props.entityId)
      entity.vernacular = entity.vernacular ? entity.vernacular.join("\n") : []
      entity.methodSeeding = entity.methodSeeding ? entity.methodSeeding.join("\n") : []
      entity.methodPlanting = entity.methodPlanting ? entity.methodPlanting.join("\n") : []
      entity.methodGrowing = entity.methodGrowing ? entity.methodGrowing.join("\n") : []
      entity.methodHarvesting = entity.methodHarvesting ? entity.methodHarvesting.join("\n") : []
      entity.methodConservation = entity.methodConservation ? entity.methodConservation.join("\n") : []
      entity.methodUtilization = entity.methodUtilization ? entity.methodUtilization.join("\n") : []
      entity.importantNote = entity.importantNote ? entity.importantNote.join("\n") : []
      entity.characteristics = entity.characteristics ? entity.characteristics : []
      entity.media = entity.media ? entity.media : []
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity }, this.getRelatedEntities)
    } else {
      this.getRelatedEntities()
    }
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    Promise.all([getPeriods(), getCharacTypes(), getCharacteristics({ itemsPerPage: 1000 }), getFamilies({ itemsPerPage: 1000 }), getPlants({ itemsPerPage: 1000 })]).then((promisesResults) => {
      let [periods, characTypes, characteristics, families, plants] = promisesResults
      this.dMgr.debug("getRelatedEntities done")

      let sortedPlantCharacteristics = this.sortCharacteristics(characTypes["hydra:member"])

      let chunkedCharacTypes = []
      const chunkSize = Math.ceil(characTypes["hydra:member"].length / 2)
      for (let i = 0; i < characTypes["hydra:member"].length; i += chunkSize) {
        chunkedCharacTypes.push(characTypes["hydra:member"].slice(i, i + chunkSize))
      }

      this.dMgr.debug("chunkedCharacTypes", chunkedCharacTypes)

      this.setState({
        periods: periods["hydra:member"],
        periodsAsObject: getObjectIdKey(periods["hydra:member"]),
        characTypes: characTypes["hydra:member"],
        characTypesAsObject: getObjectIdKey(characTypes["hydra:member"]),
        characteristics: characteristics["hydra:member"],
        characteristicsAsObject: getObjectIdKey(characteristics["hydra:member"]),
        sortedPlantCharacteristics,
        chunkedCharacTypes: chunkedCharacTypes,
        families: families["hydra:member"],
        familiesAsObject: getObjectIdKey(families["hydra:member"]),
        plants: plants["hydra:member"],
        plantsAsObject: getObjectIdKey(plants["hydra:member"]),
        isReadyToRender: true,
      })
    })
    // /CONFIG =================================================================================================
  }

  sortCharacteristics(characTypes) {
    let sortedCharacteristics = {}

    characTypes.forEach((characType) => {
      sortedCharacteristics[characType.id] = []
    })

    if (this.state.entity.characteristics && this.state.entity.characteristics.length > 0) {
      this.state.entity.characteristics.forEach((characteristic) => {
        sortedCharacteristics[characteristic.characType.id].push(characteristic)
      })
    }

    this.dMgr.debug("sortedCharacteristics", sortedCharacteristics)

    return sortedCharacteristics
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      // statementFr: Yup.string().required(this.props.t("message.required")),
      // statementEn: Yup.string().required(this.props.t("message.required")),
      // responseType: Yup.object().test("is-empty", this.props.t("message.required"), (value) => value && Object.keys(value).length > 0),
      // questionType: Yup.object().test("is-empty", this.props.t("message.required"), (value) => value && Object.keys(value).length > 0),
    })
    // /CONFIG =================================================================================================
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)
    let entity = cleanEntity(values)

    if (entity.family) {
      entity.family = ENDPOINT_FAMILIES + "/" + entity.family.id
    }

    console.log(entity.media)
    entity.media = entity.media.map((key) => {
      return ENDPOINT_MEDIAS + "/" + entity.media[key].id
    })

    entity.characteristics = Object.keys(entity.characteristics).map((key) => {
      return ENDPOINT_CHARACTERISTICS + "/" + entity.characteristics[key].id
    })

    entity.fellows = Object.keys(entity.fellows).map((key) => {
      if (entity.fellows[key].fellowId !== undefined) {
        return entity.fellows[key]
      } else {
        return ENDPOINT_FELLOWS + "/" + entity.fellows[key].id
      }
    })

    if (!Array.isArray(entity.vernacular)) {
      entity.vernacular = entity.vernacular.split("\n")

      entity.vernacular = Object.keys(entity.vernacular)
        .filter((key) => {
          if (entity.vernacular[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.vernacular[key]
        })
    }

    if (!Array.isArray(entity.methodSeeding)) {
      entity.methodSeeding = entity.methodSeeding.split("\n")

      entity.methodSeeding = Object.keys(entity.methodSeeding)
        .filter((key) => {
          if (entity.methodSeeding[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodSeeding[key]
        })
    }

    if (!Array.isArray(entity.methodPlanting)) {
      entity.methodPlanting = entity.methodPlanting.split("\n")

      entity.methodPlanting = Object.keys(entity.methodPlanting)
        .filter((key) => {
          if (entity.methodPlanting[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodPlanting[key]
        })
    }

    if (!Array.isArray(entity.methodGrowing)) {
      entity.methodGrowing = entity.methodGrowing.split("\n")

      entity.methodGrowing = Object.keys(entity.methodGrowing)
        .filter((key) => {
          if (entity.methodGrowing[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodGrowing[key]
        })
    }

    if (!Array.isArray(entity.methodHarvesting)) {
      entity.methodHarvesting = entity.methodHarvesting.split("\n")

      entity.methodHarvesting = Object.keys(entity.methodHarvesting)
        .filter((key) => {
          if (entity.methodHarvesting[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodHarvesting[key]
        })
    }

    if (!Array.isArray(entity.methodConservation)) {
      entity.methodConservation = entity.methodConservation.split("\n")

      entity.methodConservation = Object.keys(entity.methodConservation)
        .filter((key) => {
          if (entity.methodConservation[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodConservation[key]
        })
    }

    if (!Array.isArray(entity.methodUtilization)) {
      entity.methodUtilization = entity.methodUtilization.split("\n")

      entity.methodUtilization = Object.keys(entity.methodUtilization)
        .filter((key) => {
          if (entity.methodUtilization[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.methodUtilization[key]
        })
    }

    if (!Array.isArray(entity.periodSeedGlass)) {
      entity.periodSeedGlass = entity.periodSeedGlass.split(",")

      entity.periodSeedGlass = Object.keys(entity.periodSeedGlass)
        .filter((key) => {
          if (entity.periodSeedGlass[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.periodSeedGlass[key]
        })
    }

    if (!Array.isArray(entity.periodSeedSoil)) {
      entity.periodSeedSoil = entity.periodSeedSoil.split(",")

      entity.periodSeedSoil = Object.keys(entity.periodSeedSoil)
        .filter((key) => {
          if (entity.periodSeedSoil[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.periodSeedSoil[key]
        })
    }

    if (!Array.isArray(entity.periodPlanting)) {
      entity.periodPlanting = entity.periodPlanting.split(",")

      entity.periodPlanting = Object.keys(entity.periodPlanting)
        .filter((key) => {
          if (entity.periodPlanting[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.periodPlanting[key]
        })
    }

    if (!Array.isArray(entity.periodFlowering)) {
      entity.periodFlowering = entity.periodFlowering.split(",")

      entity.periodFlowering = Object.keys(entity.periodFlowering)
        .filter((key) => {
          if (entity.periodFlowering[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.periodFlowering[key]
        })
    }

    if (!Array.isArray(entity.periodHarvesting)) {
      entity.periodHarvesting = entity.periodHarvesting.split(",")

      entity.periodHarvesting = Object.keys(entity.periodHarvesting)
        .filter((key) => {
          if (entity.periodHarvesting[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.periodHarvesting[key]
        })
    }

    if (!Array.isArray(entity.importantNote)) {
      entity.importantNote = entity.importantNote.split("\n")

      entity.importantNote = Object.keys(entity.importantNote)
        .filter((key) => {
          if (entity.importantNote[key] !== "") {
            return true
          } else {
            return false
          }
        })
        .map((key) => {
          return entity.importantNote[key]
        })
    }

    try {
      // CONFIG ==================================================================================================

      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postPlant(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchPlant(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      // this.props.router.nav({
      //   prefix: "admin",
      //   entitiesType: this.props.entitiesType,
      // })
      window.location.reload()
      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container fluid>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              {/* {console.log("Formik values:", values)}
              {console.log("Formik errors:", errors)}
              {console.log("Formik touched:", touched)} */}

              <Row>
                <Col md={12}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={12} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={3}>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Nom :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formName">
                                  <Field as={Form.Control} name="name" isInvalid={touched.name && errors.name} onChange={handleChange} value={values.name} />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="name" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Latin :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formLatin">
                                  <Field as={Form.Control} name="latin" isInvalid={touched.latin && errors.latin} onChange={handleChange} value={values.latin} />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="latin" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Famille :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formFamily">
                                  <Select
                                    id="input_select_family"
                                    classNamePrefix="custom-react-select"
                                    // placeholder={this.props.t("form.question")}
                                    className={`react-select ${touched.family && errors.family ? "react-select-invalid" : ""}`}
                                    name="family"
                                    options={this.state.families
                                      // .filter((question) => {
                                      //   return question.isVisible
                                      // })
                                      .sort((a, b) => {
                                        if (a["name"] < b["name"]) {
                                          return -1
                                        }
                                        if (a["name"] > b["name"]) {
                                          return 1
                                        }
                                        return 0
                                      })
                                      .map((family) => {
                                        return {
                                          value: family,
                                          label: family.name,
                                        }
                                      })}
                                    defaultValue={
                                      values.family !== undefined
                                        ? {
                                            value: values.family,
                                            label: values.family.name,
                                          }
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFieldValue("family", e.value)
                                    }}
                                  />

                                  {touched.question && errors.question && <div className="invalid-feedback d-block">{errors.question}</div>}
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Vernaculaires :
                              </Col>
                              <Col md={9} className="margin-top-">
                                <Form.Group controlId="formVernacular">
                                  <Field as="textarea" rows={6} name="vernacular" onChange={handleChange} value={values.vernacular} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="vernacular" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Plante potagère :
                              </Col>
                              <Col md={9} className="margin-top-">
                                <Form.Check
                                  className="margin-top-8"
                                  type="checkbox"
                                  id={"gardeningPlant"}
                                  value={values.isGardeningPlant}
                                  checked={values.isGardeningPlant === "true" || values.isGardeningPlant === true}
                                  onChange={(e) => {
                                    console.log(e, e.target.checked)
                                    setFieldValue("isGardeningPlant", e.target.checked)
                                  }}
                                />
                              </Col>
                            </Row>

                            <hr />
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Semis serre :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formPeriodSeedGlass">
                                  <Field
                                    as={Form.Control}
                                    name="periodSeedGlass"
                                    isInvalid={touched.periodSeedGlass && errors.periodSeedGlass}
                                    onChange={handleChange}
                                    value={values.periodSeedGlass}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="periodSeedGlass" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Semis terre :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formPeriodSeedSoil">
                                  <Field as={Form.Control} name="periodSeedSoil" isInvalid={touched.periodSeedSoil && errors.periodSeedSoil} onChange={handleChange} value={values.periodSeedSoil} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="periodSeedSoil" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Plantation :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formPeriodPlanting">
                                  <Field as={Form.Control} name="periodPlanting" isInvalid={touched.periodPlanting && errors.periodPlanting} onChange={handleChange} value={values.periodPlanting} />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="periodPlanting" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Floraison :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formPeriodFlowering">
                                  <Field
                                    as={Form.Control}
                                    name="periodFlowering"
                                    isInvalid={touched.periodFlowering && errors.periodFlowering}
                                    onChange={handleChange}
                                    value={values.periodFlowering}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="periodFlowering" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Récolte :
                              </Col>
                              <Col md={9}>
                                <Form.Group controlId="formPeriodHarvesting">
                                  <Field
                                    as={Form.Control}
                                    name="periodHarvesting"
                                    isInvalid={touched.periodHarvesting && errors.periodHarvesting}
                                    onChange={handleChange}
                                    value={values.periodHarvesting}
                                  />
                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="periodHarvesting" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-center">
                                <PlantsPeriodsGraph plants={[this.state.entity]} displayPeriodNumbers={true} canvasWindowWidth={600} />
                              </Col>
                            </Row>

                            <hr />
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Productivité :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formProductivité">
                                  <Field
                                    as={Form.Control}
                                    name="productivity"
                                    isInvalid={touched.productivity && errors.productivity}
                                    onChange={handleChange}
                                    value={values.productivity}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="productivity" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Croissance :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formGrowth">
                                  <Field as={Form.Control} name="growth" isInvalid={touched.growth && errors.growth} onChange={handleChange} value={values.growth} type="number" min="-1" max="5" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="growth" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Feuillage :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formFoliage">
                                  <Field
                                    as={Form.Control}
                                    name="foliage"
                                    isInvalid={touched.foliage && errors.foliage}
                                    onChange={handleChange}
                                    value={values.foliage}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="growth" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Hauteur plante :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formHeightPlant">
                                  <Field
                                    as={Form.Control}
                                    name="heightPlant"
                                    isInvalid={touched.heightPlant && errors.heightPlant}
                                    onChange={handleChange}
                                    value={values.heightPlant}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="heightPlant" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Taille produit :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formSizeProduct">
                                  <Field
                                    as={Form.Control}
                                    name="sizeProduct"
                                    isInvalid={touched.sizeProduct && errors.sizeProduct}
                                    onChange={handleChange}
                                    value={values.sizeProduct}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="sizeProduct" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Besoin soleil :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formNeedSun">
                                  <Field
                                    as={Form.Control}
                                    name="needSun"
                                    isInvalid={touched.needSun && errors.needSun}
                                    onChange={handleChange}
                                    value={values.needSun}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="needSun" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Besoin eau :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formNeedWater">
                                  <Field
                                    as={Form.Control}
                                    name="needWater"
                                    isInvalid={touched.needWater && errors.needWater}
                                    onChange={handleChange}
                                    value={values.needWater}
                                    type="number"
                                    min="-1"
                                    max="10"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="needWater" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Prof semis (mm) :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formSeedingDepth">
                                  <Field
                                    as={Form.Control}
                                    name="seedingDepth"
                                    isInvalid={touched.seedingDepth && errors.seedingDepth}
                                    onChange={handleChange}
                                    value={values.seedingDepth}
                                    type="number"
                                    min="0"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="sizeProduct" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Dist. plants (cm) :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formDistanceBetweenPlants">
                                  <Field
                                    as={Form.Control}
                                    name="distanceBetweenPlants"
                                    isInvalid={touched.distanceBetweenPlants && errors.distanceBetweenPlants}
                                    onChange={handleChange}
                                    value={values.distanceBetweenPlants}
                                    type="number"
                                    min="0"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="distanceBetweenPlants" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={3} className="margin-top-8 text-end">
                                Dist. rangés (cm) :
                              </Col>
                              <Col md={5}>
                                <Form.Group controlId="formDistanceBetweenRows">
                                  <Field
                                    as={Form.Control}
                                    name="distanceBetweenRows"
                                    isInvalid={touched.distanceBetweenRows && errors.distanceBetweenRows}
                                    onChange={handleChange}
                                    value={values.distanceBetweenRows}
                                    type="number"
                                    min="0"
                                  />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="distanceBetweenRows" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>

                          {/* =============================================================================================================================== */}

                          <Col md={1}>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Amis :</div>
                                <ul>
                                  {this.state.plants
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((plant) => {
                                      let disabled = plant.id === this.state.entity.id

                                      let isChecked = false

                                      if (this.state.entity.fellows) {
                                        this.state.entity.fellows.forEach((fellowship) => {
                                          // console.log(fellowship.fellowId, plant.id)

                                          if ((fellowship.fellow.id === plant.id || fellowship.fellowId === plant.id) && fellowship.isFriend) {
                                            isChecked = true
                                          }

                                          // console.log(fellowship.fellowId, plant.id, isChecked)
                                        })
                                      }

                                      return (
                                        <li className="li-no-bullet" key={"fellow_friends_" + plant.id}>
                                          <Form.Check
                                            type="checkbox"
                                            id={"fellow_friends_" + plant.id}
                                            value={plant.id}
                                            label={plant.name}
                                            disabled={disabled}
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const { checked } = e.target
                                              const value = parseInt(e.target.value)

                                              let currentEntity = { ...this.state.entity }

                                              if (checked) {
                                                let newFellow = {
                                                  plant: ENDPOINT_PLANTS + "/" + this.state.entity.id,
                                                  isFriend: true,
                                                  fellow: ENDPOINT_PLANTS + "/" + value,
                                                  fellowId: value,
                                                }

                                                currentEntity.fellows.push(newFellow)
                                              } else {
                                                for (let i = 0; i < this.state.entity.fellows.length; i++) {
                                                  // console.log(i, this.state.entity.fellows[i].fellow.id, this.state.entity.fellows[i].fellowId, value, this.state.entity.fellows[i].fellow)
                                                  if ((this.state.entity.fellows[i].fellow.id === value || this.state.entity.fellows[i].fellowId === value) && this.state.entity.fellows[i].isFriend) {
                                                    // console.log(i)
                                                    currentEntity.fellows.splice(i, 1)
                                                  }
                                                }
                                              }

                                              setFieldValue("fellows", currentEntity.fellows)
                                            }}
                                          />
                                        </li>
                                      )
                                    })}
                                </ul>
                              </Col>
                            </Row>
                          </Col>

                          <Col md={1}>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Ennemis :</div>
                                <ul>
                                  {this.state.plants
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((plant) => {
                                      let disabled = plant.id === this.state.entity.id

                                      let isChecked = false
                                      if (this.state.entity.fellows) {
                                        this.state.entity.fellows.forEach((fellowship) => {
                                          // console.log(fellowship.fellowId, plant.id)

                                          if ((fellowship.fellow.id === plant.id || fellowship.fellowId === plant.id) && !fellowship.isFriend) {
                                            isChecked = true
                                          }

                                          // console.log(fellowship.fellowId, plant.id, isChecked)
                                        })
                                      }

                                      return (
                                        <li className="li-no-bullet" key={"fellow_ennemies_" + plant.id}>
                                          <Form.Check
                                            type="checkbox"
                                            id={"fellow_ennemies_" + plant.id}
                                            value={plant.id}
                                            label={plant.name}
                                            disabled={disabled}
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const { checked } = e.target
                                              const value = parseInt(e.target.value)

                                              let currentEntity = { ...this.state.entity }

                                              if (checked) {
                                                let newFellow = {
                                                  plant: ENDPOINT_PLANTS + "/" + this.state.entity.id,
                                                  isFriend: false,
                                                  fellow: ENDPOINT_PLANTS + "/" + value,
                                                  fellowId: value,
                                                }

                                                currentEntity.fellows.push(newFellow)
                                              } else {
                                                for (let i = 0; i < this.state.entity.fellows.length; i++) {
                                                  // console.log(i, this.state.entity.fellows[i].fellow.id, value)
                                                  if ((this.state.entity.fellows[i].fellow.id === value || this.state.entity.fellows[i].fellowId === value) && !this.state.entity.fellows[i].isFriend) {
                                                    // console.log(i)
                                                    currentEntity.fellows.splice(i, 1)
                                                  }
                                                }
                                              }

                                              setFieldValue("fellows", currentEntity.fellows)
                                            }}
                                          />
                                        </li>
                                      )
                                    })}
                                </ul>
                              </Col>
                            </Row>
                          </Col>

                          <Col md={3}>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode semis :</div>
                                <Form.Group controlId="formMethodSeeding">
                                  <Field as="textarea" rows={4} name="methodSeeding" onChange={handleChange} value={values.methodSeeding} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodSeeding" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode plantation :</div>
                                <Form.Group controlId="formMethodPlanting">
                                  <Field as="textarea" rows={4} name="methodPlanting" onChange={handleChange} value={values.methodPlanting} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodPlanting" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode culture :</div>
                                <Form.Group controlId="formMethodGrowing">
                                  <Field as="textarea" rows={4} name="methodGrowing" onChange={handleChange} value={values.methodGrowing} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodGrowing" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode récolte :</div>
                                <Form.Group controlId="formMethodHarvesting">
                                  <Field as="textarea" rows={4} name="methodHarvesting" onChange={handleChange} value={values.methodHarvesting} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodHarvesting" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode conservation :</div>
                                <Form.Group controlId="formMethodConservation">
                                  <Field as="textarea" rows={4} name="methodConservation" onChange={handleChange} value={values.methodConservation} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodConservation" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Méthode utilisation :</div>
                                <Form.Group controlId="formMethodUtilization">
                                  <Field as="textarea" rows={4} name="methodUtilization" onChange={handleChange} value={values.methodUtilization} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="methodUtilization" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="margin-top-8">
                              <Col md={12} className="margin-top-8 text-ends">
                                <div>Notes importantes :</div>
                                <Form.Group controlId="formImportantNote">
                                  <Field as="textarea" rows={4} name="importantNote" onChange={handleChange} value={values.importantNote} className="width-100p textarea-resize-none" />

                                  <Form.Control.Feedback type="bgalid">
                                    <ErrorMessage name="importantNote" />
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>

                          <Col md={4}>
                            <Row>
                              {this.state.chunkedCharacTypes.map((characTypeChunk, index) => {
                                return (
                                  <Col key={"ColcharacTypeChunk_" + index}>
                                    {characTypeChunk.map((characType) => {
                                      let characteristics = this.state.characteristics.filter((characteristic) => characteristic.characType.id === characType.id)

                                      return (
                                        <Row className="margin-top-8" key={"characType" + characType.id}>
                                          <Col md={12}>
                                            <h5>{characType.name}</h5>
                                            <ul>
                                              {characteristics
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((characteristic, index) => {
                                                  // Vérifier si la caractéristique est déjà présente dans entity.characteristics
                                                  const isChecked = values.characteristics.some((plantCharacteristic) => plantCharacteristic.id === characteristic.id)

                                                  return (
                                                    <li className="li-no-bullet" key={"characteristic_" + characteristic.id}>
                                                      <Form.Check
                                                        type="checkbox"
                                                        id={"characteristic_" + characteristic.id}
                                                        value={characteristic.id}
                                                        label={characteristic.name}
                                                        checked={isChecked}
                                                        onChange={(e) => {
                                                          let characteristic = this.state.characteristicsAsObject[parseInt(e.target.value)]

                                                          // let currentEntity = { ...this.state.entity }
                                                          // console.log(values.methodSeeding, e.target.checked, characteristic.id)

                                                          let updatedCharacteristics

                                                          if (e.target.checked) {
                                                            updatedCharacteristics = [...values.characteristics]
                                                            updatedCharacteristics.push(characteristic)
                                                          } else {
                                                            updatedCharacteristics = values.characteristics.filter((plantCharacteristic) => plantCharacteristic.id !== characteristic.id)
                                                          }

                                                          values.characteristics = updatedCharacteristics

                                                          // this.setState({ entity: currentEntity })

                                                          setFieldValue("characteristics", updatedCharacteristics)
                                                        }}
                                                      />
                                                    </li>
                                                  )
                                                })}
                                            </ul>
                                          </Col>
                                        </Row>
                                      )
                                    })}
                                  </Col>
                                )
                              })}
                            </Row>
                          </Col>
                        </Row>
                        <br />

                        <Row>
                          <Col md={5}></Col>
                          <Col md={1} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={1} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(PlantForm)
